<template>
  <b-overlay :show="showOverlay">
    <validation-observer ref="createNetworkRef" tag="div">
      <b-card>
        <strong>Create Wallet Network</strong>
<!--Input Fields -->
        <b-form v-if="data" class="my-1">
          <b-row>
<!-- Field: name -->
            <b-col
                cols="12"
                md="4"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-group
                    label="Network Name"
                >

                  <b-form-input
                      v-model="data.name"
                      :state="errors.length > 0 ? false:null"
                  />
                </b-form-group>

              </validation-provider>
            </b-col>

<!-- Field:  symbol -->
            <b-col
                cols="12"
                md="4"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >

                <b-form-group
                    label="Symbol"
                >
                  <b-form-input
                      id="symbol"
                      v-model="data.symbol"
                      :state="errors.length > 0 ? false:null"
                  />
                </b-form-group>

              </validation-provider>
            </b-col>

<!-- Field:  Network Status -->
            <b-col
                cols="12"
                md="4"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >

                <b-form-group
                    label="Network Status"
                >
                  <v-select
                      v-model="data.isActive"
                      :clearable="false"
                      :options="networkStatuses"
                      input-id="network-status"
                      :reduce="name => name.value"
                      label="name"
                      :state="errors.length > 0 ? false:null"
                  />
                </b-form-group>

              </validation-provider>
            </b-col>
          </b-row>
        </b-form>

<!-- Action Buttons -->
        <b-button
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            variant="primary"
            @click="createNetworkWallet"
        >
          Create
        </b-button>

      </b-card>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BOverlay,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import MediaHandler from '@/views/components/utilities/MediaHandler.vue'
import { required } from '@validations'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Helper from '@/libs/Helper'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {CreateWalletNetworks} from '@/libs/Api/Networks'


export default {
  title: 'Create Wallet Network',

  data() {
    return {
      required,
      networkStatuses: [
          {
          name: 'Active',
          value: true
        },
        {
          name: 'InActive',
          value: false
        },
      ],
      data: {
        name: '',
        symbol: '',
        isActive: null,
      },
      showOverlay: false,
    }
  },

  computed: {},

  methods: {
    async createNetworkWallet() {
      let _this = this
      Helper.validateForm(_this, 'createNetworkRef', async () => {
        _this.showOverlay = true
        let createWalletNetworks = new CreateWalletNetworks(_this)

        createWalletNetworks.setPayload(_this.data)


        await createWalletNetworks.fetch(function (content) {
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: `success`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `Wallet Network Successfully Created`,
            },
          })

          _this.showOverlay = false
          _this.$router.push('/apps/wallet-networks/networksList')
        }, function (error) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              text: error.message,
              title: `error`,
              variant: 'danger',
            },
          })
          _this.showOverlay = false
        })
      })
    },
  },

  components: {
    MediaHandler,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BOverlay,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
